module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/c0d3c34173322a99e5528bd08505f2dd.png";